import React, { useState } from "react";
import "../styles/featuresStyle.css";

export default function Features({ index }) {
  const [features] = useState([
    {
      title: "Enjoy on your TV.",
      text:
        "Watch on Smart TVs, Playstation, Xbox, Chromecast, Apple TV, Blu-ray players, and more.",
      imgSrc: require("../../assets/images/tab-tv.png"),
    },
    {
      title: "Download your shows to watch offline.",
      text: "Save your favorites easily and always have something to watch.",
      imgSrc: require("../../assets/images/tab-tablet.png"),
    },
    {
      title: "Watch everywhere.",
      text:
        "Stream unlimited movies and TV shows on your phone, tablet, laptop, and TV without paying more.",
      imgSrc: require("../../assets/images/tab-macbook.png"),
    },
  ]);

  return (
    <div>
      <div className="container-fluid d-flex justify-content-center">
        {index != 1 ? (
          <div className="row container">
            <div className="text-container text-light col-xl-6 col-lg-6 col-sm-12 col-xs-12">
              <div>
                <div className="mb-3">
                  <h1 className="title">{features[index].title}</h1>
                </div>
                <div>
                  <h3 className="text">{features[index].text}</h3>
                </div>
              </div>
            </div>
            <div className="col-xl-6 col-lg-6 col-sm-12 col-xs-12">
              <img height={300} src={features[index].imgSrc} />
            </div>
          </div>
        ) : (
          <div className="row container">
            <div className="col-xl-6 col-lg-6 col-sm-12 col-xs-12">
              <img height={300} src={features[index].imgSrc} />
            </div>
            <div className="text-container text-light col-xl-6 col-lg-6 col-sm-12 col-xs-12">
              <div>
                <div className=" mb-3">
                  <h1 className="title">{features[index].title}</h1>
                </div>
                <div>
                  <h3 className="text">{features[index].text}</h3>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
